import React, {PureComponent} from 'react';
import Panel from '../../../components/Panel';
import {AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer} from 'recharts';
import * as TextManager from "../../../modules/languages/TextManager";

export default class FtdsVsSignups extends PureComponent {
  render() {
    return (
      <Panel md={12} lg={12} xl={12} title={TextManager.getCurrentTextResource().Text.dealsVsLines}>
        <ResponsiveContainer height={250} className='dashboard__area'>
          <AreaChart data={this.props.data} margin={{top: 20, left: -15, bottom: 20}}>
            <XAxis dataKey='date' tickLine={false}/>
            <YAxis tickLine={false}/>
            <Tooltip/>
            <Legend/>
            <CartesianGrid/>
            <Area name={TextManager.getCurrentTextResource().Text.deals} type='monotone' dataKey='deals' fill='#4ce1b6' stroke='#4ce1b6' fillOpacity={0.2}/>
            <Area name={TextManager.getCurrentTextResource().Text.lines} type='monotone' dataKey='newLines' fill='#70bbfd' stroke='#70bbfd' fillOpacity={0.2}/>
          </AreaChart>
        </ResponsiveContainer>
      </Panel>
    )
  }
}

